import "leaflet";
import "leaflet-marker-rotation";
import "Leaflet.MultiOptionsPolyline";
import "jquery-ui/dist/jquery-ui";
import "./vendor/jquery.nouislider.all.min.js";
import "bootstrap";
import _ from "lodash";

globalThis._ = _;
